<template>
  <div>
    <div class="overlay" :class="overlayClass">
      <perfect-scrollbar class="wrapper">
        <span class="close-btn">
          <a class="icon-cancel-1 close-overlay" @click="$emit('close')"
            >Close</a
          >
        </span>
        <div class="content full-content" :class="{ logedIn: isLogin }">
          <div class="p-r" style="min-height: 38px">
            <span
              class="d-ib"
              data-title="Edit Post"
              data-title-top
              v-if="post.life_support === true"
            >
              <a
                v-show="isLogin && user.email === post.author_email"
                class="button basic tertiary icon-edit pd-10-15 mr-10"
                @click="editPost"
              ></a>
            </span>
            <span class="d-ib" data-title="Delete Post" data-title-top>
              <a
                v-show="isLogin && user.email === post.author_email"
                class="button basic tertiary icon-trash pd-10-15 mr-10"
                @click="removePost"
              ></a>
            </span>

            <span
              class="d-ib"
              :data-title="`${
                diableFavorite ? 'Remove from Faves' : 'Add to Faves'
              }`"
              data-title-top
              @click="clickFavButton"
            >
              <a
                v-show="isLogin && user.email !== post.author_email"
                class="button basic tertiary icon-heart pd-10-15 mr-10"
                :class="{ liked: diableFavorite }"
              ></a>
            </span>

            <span
              class="d-ib for-btn"
              :data-title="`${disableFollow ? 'Following' : 'Follow'} ${
                post.author
              }`"
              data-title-top
            >
              <a
                v-show="isLogin && user.email !== post.author_email"
                class="button basic tertiary icon-user pd-10-15 mr-10"
                :class="{ follow: disableFollow }"
                @click="clickButton"
              >
                <span class="plus">+</span>
              </a>
            </span>
            <div v-if="showVoter" class="loged-innp-btns cst-right">
              <a
                v-if="hasNext"
                class="button tertiary right nxt tip-next"
                @click="$emit('showOtherPost', 1)"
                data-title="Next Post"
                data-title-bottom
              >
                Next
                <i class="icon-right-open"></i>
              </a>
              <a
                v-if="hasPrev"
                class="button tertiary right prv tip-pre"
                :class="!hasNext ? 'left-0' : ''"
                @click="$emit('showOtherPost', -1)"
                data-title="Previous Post"
                data-title-left
              >
                <i class="icon-left-open"></i>
                <strong>Prev</strong>
              </a>
            </div>
            <div
              v-else
              class="loged-outnp-btns cmn-loged cst-left"
              :class="{ 'left-0': hasNext, 'right-0': hasPrev }"
            >
              <a
                v-if="hasNext"
                class="button tertiary right nxt tip-next"
                @click="$emit('showOtherPost', 1)"
                data-title="Next Post"
                data-title-bottom
              >
                Next
                <i class="icon-right-open"></i>
              </a>
              <a
                v-if="hasPrev"
                class="button tertiary right prv tip-pre"
                :class="!hasNext ? 'left-0' : ''"
                @click="$emit('showOtherPost', -1)"
                data-title="Previous Post"
                data-title-left
              >
                <i class="icon-left-open"></i>
                <strong>Prev</strong>
              </a>
            </div>
            <div v-if="this.$route.path !== '/' && isLogin">
              <span
                v-if="
                  showVoter && this.post.life_support && this.post.votes > 0
                "
                class="actual-count p-a"
                title="Precise position"
              >
                {{ pressure }}<span>%</span>
              </span>
              <span
                class="actual-count p-a no_vote"
                v-else-if="showVoter && this.post.life_support"
                >NO VOTES YET</span
              >
              <span class="actual-count p-a no_vote" v-else>
                <span> O<sup>2</sup> EXPIRED </span>
              </span>
            </div>
          </div>
          <ul class="feed">
            <li>
              <h2 id="postTitle">{{ post.title }}</h2>
              <div class="relative">
                <div>
                  <div>
                    <div
                      class="voter"
                      v-if="
                        showVoter &&
                        this.post.life_support &&
                        post.bane_post === false
                      "
                    >
                      <div class="votes cst-tooltip cst-move-right">
                        <div
                          class="votes only_plus"
                          :class="[
                            myVotes && max_votes !== post.post_id
                              ? ''
                              : 'count_up',
                          ]"
                        >
                          <div class="votes-nav">
                            <div
                              data-title="Vote me up the Leaderboard"
                              data-title-right
                            >
                              <div v-if="this.$route.path === '/'">
                                <div
                                  v-if="myVotes && post.post_id !== max_votes"
                                  class="icon-plus votes-button votes-up tippy"
                                  @click="increment(post.post_id)"
                                ></div>
                              </div>
                              <div v-if="this.$route.path === '/leaderboard'">
                                <div
                                  v-if="myVotes && post.post_id !== max_votes"
                                  class="icon-plus votes-button votes-up tippy"
                                  @click="increment(post.post_id)"
                                ></div>
                              </div>
                              <div v-else-if="this.$route.path === '/user'">
                                <div
                                  v-if="myVotes && post.post_id !== max_votes"
                                  class="icon-plus votes-button votes-up tippy"
                                  @click="userIncrement(post.post_id)"
                                ></div>
                              </div>
                              <div v-else-if="this.$route.path === '/search'">
                                <div
                                  v-if="myVotes && post.post_id !== max_votes"
                                  class="icon-plus votes-button votes-up tippy"
                                  @click="searchIncrement(post.post_id)"
                                ></div>
                              </div>
                              <div
                                v-else-if="
                                  this.$route.path === '/favoriteposts'
                                "
                              >
                                <div
                                  v-if="myVotes && post.post_id !== max_votes"
                                  class="icon-plus votes-button votes-up tippy"
                                  data-tooltip="Pressure Up"
                                  @click="favIncrement(post.post_id)"
                                ></div>
                              </div>
                              <div
                                v-else-if="
                                  this.$route.path !== '/' &&
                                  this.$route.path !== '/leaderboard' &&
                                  this.$route.path !== '/favoritePosts' &&
                                  this.$route.path !== '/user'
                                "
                              >
                                <div
                                  v-if="myVotes && post.post_id !== max_votes"
                                  class="icon-plus votes-button votes-up tippy"
                                  title="Pressure Up"
                                  @click="profileIncrement(post.post_id)"
                                ></div>
                              </div>
                            </div>
                            <div data-title="Pressure Down" data-title-right>
                              <div class="votes-down-warp">
                                <div>
                                  <div
                                    v-if="
                                      this.$route.path !== '/' &&
                                      this.$route.path !== '/user' &&
                                      post.votes &&
                                      myVotes &&
                                      post.post_id !== min_votes
                                    "
                                    class="
                                      icon-minus
                                      votes-button votes-down
                                      tippy
                                    "
                                    @click="$emit('decrement', post.post_id)"
                                  ></div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="cst_input" v-if="post.votes > 0">
                            <div v-if="this.$route.path === '/'">
                              <div
                                v-if="max_votes !== post.post_id"
                                class="cst_input value_center"
                              >
                                <div
                                  data-title="Votes received"
                                  data-title-right
                                >
                                  <input
                                    type="number"
                                    id="z2h-05b-votes"
                                    :value="post.votes"
                                    min="0"
                                    step="1"
                                    oninput="checkLength(5,this)"
                                  />
                                </div>
                              </div>
                              <div
                                class="with_box"
                                v-else-if="max_votes === post.post_id"
                              >
                                <div
                                  data-title="Top of the Leaderboard"
                                  data-title-right
                                >
                                  CURRENT LEADER
                                </div>
                              </div>
                            </div>
                            <div class="cst_input" v-else>
                              <div
                                data-title="Leaderboard Position"
                                data-title-right
                              >
                                <input
                                  type="number"
                                  id="z2h-05b-votes"
                                  :value="pressure"
                                  min="0"
                                  step="1"
                                  oninput="checkLength(5,this)"
                                />
                                <span>%</span>
                              </div>
                            </div>
                          </div>

                          <div class="no_count" v-else-if="post.votes < 1">
                            <div data-title="Help Me!" data-title-right>
                              NO VOTES YET
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="thank_you"
                  :class="[post.post_id === post_id ? 'show' : '']"
                  :id="`msgID${post.post_id}`"
                >
                  <canvas
                    class="confetti"
                    :id="`overlay-canvas${post.post_id}`"
                  ></canvas>

                  <div class="message">
                    <p>THANK YOU!</p>
                    <span>This Post is now on the Leaderboard</span>
                  </div>
                </div>
                <div class="imgWrap" v-if="post.images.length">
                  <!-- POST IMAGE / MULTI-IMAGE SLIDESHOW / VIDEO WRAP -->
                  <div class="post-life">
                    <life-remaining-bar-component
                      v-if="post.life_support"
                      :expiration="post.expiration"
                      :life_remaining="post.life_support_remaining"
                    />
                    <div
                      class="bar"
                      :class="calExpiration(post.expiration)"
                      :style="`top:${post.expiration}%`"
                      :data-title="`${limit2numbers(
                        lifeSupport
                      )} of Life-Support remain`"
                      data-title-right
                    ></div>
                  </div>
                  <div v-if="post.images.length < 2">
                    <img :src="post.images[0].url" />
                  </div>
                  <div class="o2img-slider" v-else>
                    <VueSlickCarousel v-bind="settings">
                      <li
                        v-for="(image, idx) in post.images"
                        :key="idx"
                        :class="{ active: activeLi === idx }"
                        @click="activeLi = idx"
                      >
                        <v-lazy-image :src="image.url" />
                      </li>
                    </VueSlickCarousel>
                  </div>
                </div>
                <div
                  class="imgWrap mt-20 daynamic-img-warp"
                  v-for="(video, index) in post.videos"
                  :key="index"
                >
                  <div class="post-life">
                    <life-remaining-bar-component
                      v-if="post.life_support"
                      :expiration="post.expiration"
                      :life_remaining="post.life_support_remaining"
                    />
                  </div>
                  <iframe
                    width="560"
                    height="315"
                    :src="video.url"
                    frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                  ></iframe>
                </div>
                <!-- END POST IMAGE / MULTI-IMAGE SLIDESHOW / VIDEO WRAP -->
                <div class="author">
                  <span class="user mr-5">
                    <i class="icon-user"></i>
                    <a
                      class="anti-a mr-0"
                      :title="`View ${post.author}`"
                      @click="goToProfile(index)"
                      >{{ post.author }}</a
                    >
                    <span>
                      <a
                        :href="link"
                        :data-title="toCapital(post.author_theme)"
                        data-title-left
                        class="user-trophy"
                        :class="trophyClass(post.author_theme)"
                      >
                        <i class="icon-award tiny"></i>
                      </a>
                    </span>
                  </span>

                  <span class="date">
                    <i class="icon-calendar"></i>
                    {{ postTimeAgo(post.post_date) }}
                  </span>
                  <span
                    :data-title="`View ${post.author}`"
                    data-title-left
                    class="tip-user"
                  >
                    <a class="avatar" @click="goToProfile">
                      <div
                        v-if="isLogin"
                        class="on-off"
                        :class="[post.author_status === true ? 'on-now' : '']"
                        :data-title="
                          post.author_status === true ? 'Online' : 'Offline'
                        "
                        data-title-right
                      ></div>
                      <img
                        class="pho-circs pho-2"
                        :src="post.author_img"
                        :alt="post.author"
                        :class="
                          post.author_class === 'no-border'
                            ? 'avatar-no-border'
                            : ''
                        "
                      />
                    </a>
                  </span>
                </div>
              </div>
              <BoostToTop
                :post_id="post.post_id"
                :author="post.author_email"
                :life="post.life_support"
                :add_time="post.add_time"
              />
              <!-- Award system -->
              <div v-if="isLogin">
                <div class="other-action-wrap">
                  <span
                    :data-title="`${
                      disableLove ? 'Remove Love' : 'Love this Post'
                    }`"
                    data-title-top
                    @click="clickLoveLikeButton('love')"
                    class="single-action"
                    v-if="user.email !== post.author_email"
                  >
                    <a
                      class="button basic icon-fire"
                      :class="disableLove ? 'secondary' : 'tertiary'"
                      >Love
                      <span v-if="loveCount" class="fs-7 ml-3">
                        ({{ loveCount }})</span
                      ></a
                    >
                  </span>
                  <span
                    :data-title="`${
                      disableLike ? 'Remove Like' : 'Like this Post'
                    }`"
                    data-title-top
                    @click="clickLoveLikeButton('like')"
                    class="single-action"
                    v-if="user.email !== post.author_email"
                  >
                    <a
                      class="button basic icon-thumbs-up"
                      :class="disableLike ? 'secondary' : 'tertiary'"
                    >
                      <span class="btn-text">Like</span>
                      <span v-if="likeCount" class="fs-7 ml-3">
                        ({{ likeCount }})
                      </span>
                    </a>
                  </span>
                  <span
                    data-title="Give this Stars"
                    data-title-top
                    @click="awardModalShow = !awardModalShow"
                    class="single-action"
                    v-if="user.email !== post.author_email"
                  >
                    <a class="button basic tertiary icon-star">
                      <span class="btn-text">Stars</span>
                      <span class="fs-7 ml-3">({{ totalStar }})</span></a
                    >
                  </span>
                  <span
                    @click="scroll('comment-box')"
                    class="single-action isMobile"
                  >
                    <a class="button basic tertiary icon-comment-empty"
                      ><span class="btn-text">Comment</span>
                      <span v-if="totalCommentsCount" class="fs-7 ml-3"
                        >({{ totalCommentsCount }})</span
                      >
                    </a>
                  </span>
                </div>
              </div>
              <p class="white-spaces-pre" id="postSummary">
                {{ post.summary }}
              </p>
              <div v-if="post.life_support" class="life-status">
                <span class="acrobat-bold text-blue text-border-left fs-16">
                  O<sup>2</sup>
                </span>
                :
                <strong class="blk fs-14">
                  {{ limit2numbers(post.life_support_remaining) }}
                </strong>
                of Life remains.
              </div>
              <div v-else class="life-status">
                <span class="acrobat-bold text-blue text-border-left fs-16">
                  O<sup>2</sup>
                </span>
                :
                <strong class="blk">Expired.</strong> This Post cannot be voted
                on.
              </div>
              <!-- END VIDEO WRAP -->
              <p v-if="post.category.length > 0" class="ovlay modal-cate-list">
                <span class="ovlay-abs">
                  <i class="icon-list-bullet"></i>
                  CATEGORY:
                </span>
                <span
                  v-for="(cat, index) in post.category"
                  :key="index"
                  :title="cat"
                  class="cate-list"
                  >{{ cat }}</span
                >
              </p>
              <p class="ovlay mt-30 total-star" v-if="totalStar">
                <span class="ovlay-abs"> <i class="icon-star"></i>stars: </span>
                <span>{{ totalStar }}</span> &middot;
                <a @click="getCountData">
                  {{ opendCountView ? "Close" : "View " }}</a
                >
              </p>
              <div class="single-star-wrap" v-if="opendCountView">
                <div
                  class="single-star-row"
                  v-for="(item, idx) in countData"
                  :key="idx"
                >
                  <p v-if="item" class="ovlay">
                    <span class="ovlay-abs icon-star-empty">{{ idx }}:</span>
                    {{ item }}
                  </p>
                </div>
              </div>
              <p v-if="post.credit" class="ovlay mt-30">
                <span class="ovlay-abs">
                  <i class="icon-heart-empty"></i>CREDIT:
                </span>
                <span target="_blank" :href="post.credit">{{
                  post.credit
                }}</span>
              </p>
              <p v-if="post.additional_link" class="ovlay">
                <span class="ovlay-abs">
                  <i class="icon-link-ext"></i>LINK:
                </span>
                <a
                  class="anti-a"
                  target="_blank"
                  :href="post.additional_link"
                  >{{ post.additional_link }}</a
                >
              </p>
              <p v-if="post.tags.length > 0" class="ovlay">
                <span class="ovlay-abs">
                  <i class="icon-tags"></i>
                  TAGS:
                </span>
                <a
                  v-for="(tag, index) in post.tags"
                  :key="index"
                  class="anti-a f-end-tag"
                  :title="tag"
                  @click="searchTag(tag)"
                  >#{{ tag }}</a
                >
              </p>
              <p class="ovlay" v-if="post.bane_post === false">
                <span class="ovlay-abs">
                  <i class="icon-link-ext"></i>
                  URL:
                </span>
                <a
                  :href="postURL"
                  target="_blank"
                  class="anti-a"
                  id="postUrl"
                  >{{ postURL }}</a
                >

                <a
                  style="cursor: copy"
                  data-title="Copy Post link"
                  data-title-top
                  class="button tertiary copyurl"
                  rel="noopener noreferrer"
                  @click="copyURL"
                >
                  <span>{{ copyButtonText }}</span>
                </a>
              </p>
              <reportPostModal
                :show="reportModalShow"
                :post_url="postURL"
                @toggle-modal="reportModalShow = !reportModalShow"
                @handle-submit="reportPost"
              />
              <div class="pt-20">
                <div v-if="isLogin" class="post-action-bar">
                  <div class="mb-25">
                    <span class="ovlay-abs"
                      ><i class="blk icon-share"></i> SHARE:
                    </span>
                  </div>
                  <span class="report-error">
                    <a
                      v-if="user.email !== post.author_email"
                      data-title="Report to Admin"
                      data-title-left
                      class="right fs-6 anti-red"
                      @click="disableReportButton"
                    >
                      <span class="icon-flag mr-3"></span>REPORT
                    </a>
                    <span>{{ errorMessage }}</span>
                  </span>
                </div>
                <!-- share post to social media -->
                <div v-else class="mb-25">
                  <span class="ovlay-abs"
                    ><i class="blk icon-share"></i> SHARE:
                  </span>
                </div>
                <div class="social-share-links">
                  <a
                    @click="shareFacebook(post.post_id)"
                    target="_top"
                    class="icon-box fb"
                  >
                    <i class="icon-facebook"></i>
                  </a>
                  <a
                    @click="shareTwitter(post.post_id)"
                    target="_blank"
                    class="icon-box tw"
                  >
                    <i class="icon-twitter"></i>
                  </a>
                  <a
                    @click="sharePinterest(post.post_id)"
                    target="_blank"
                    class="icon-box pi"
                  >
                    <i class="icon-pinterest-circled"></i>
                  </a>
                  <a
                    @click="modalShow = !modalShow"
                    target="_blank"
                    class="icon-box mi"
                  >
                    <i class="icon-mail-alt"></i>
                  </a>
                  <modal
                    :show="modalShow"
                    @toggle-modal="modalShow = !modalShow"
                    @handle-submit="handleSubmit"
                  />
                </div>
              </div>

              <!-- Comment -->
              <div v-if="isLogin" id="comment-box">
                <div class="comment-box">
                  <div class="fieldset pb-20">
                    <label for="add-comment">
                      <i class="icon-commenting"></i>
                      Add a Comment ({{ totalCommentsCount }})
                    </label>
                    <div class="input-holder">
                      <textarea
                        v-model="commentText"
                        placeholder="Join the discussion ..."
                      ></textarea>
                    </div>
                  </div>
                  <input
                    type="submit"
                    id="submit-comment-01"
                    class="button secondary"
                    value="COMMENT"
                    @click.prevent="addComment"
                    :disabled="disableAddCommentButton || doubleClick"
                  />
                </div>
                <div
                  v-for="(comment, index) in comments"
                  :key="index"
                  class="comment"
                >
                  <div class="comment_inner">
                    <div class="main_comment_cs">
                      <span
                        @click="
                          goToCommentProfile(
                            comment.cmt_user_uuid,
                            comment.cmt_user_email
                          )
                        "
                      >
                        <div v-if="comment.cmt_user_avatar !== null">
                          <img
                            class="pho-circs pho-2"
                            :title="`View ${comment.cmt_user_fullname}`"
                            :src="comment.cmt_user_avatar"
                            :alt="comment.cmt_user_fullname"
                            :class="
                              comment.cmt_user_avatar ===
                              'https://test-o2.s3-ap-southeast-2.amazonaws.com/avatars/logo-160.png'
                                ? 'avatar-no-border'
                                : ''
                            "
                          />
                        </div>
                        <div
                          v-else
                          class="small-user-img pho-circs pho-4"
                          :title="`View ${comment.cmt_user_fullname}`"
                        ></div>
                        <div class="name_time_wrapper">
                          <span class="blue_text">
                            {{ comment.cmt_user_fullname }}
                          </span>

                          <div>{{ timeAgo(comment.cmmented_at) }}</div>
                          <div
                            v-if="comment.cmt_user_email === post.author_email"
                            class="cmt-author"
                          >
                            Author
                          </div>
                        </div>
                      </span>
                      <div class="cs_text">
                        <i>"</i>
                        {{ comment.comment }}
                        <i>"</i>
                      </div>
                      <div
                        data-title="Remove Comment"
                        data-title-left
                        class="delete_btn"
                        v-if="user.email === post.author_email"
                      >
                        <i
                          class="icon-trash com-trash"
                          @click.prevent="removeComment(index)"
                        ></i>
                      </div>
                      <div
                        data-title="Remove Comment"
                        data-title-left
                        class="delete_btn"
                        v-else
                      >
                        <i
                          v-show="user.uuid === comment.cmt_user_uuid"
                          class="icon-trash com-trash"
                          @click.prevent="removeComment(index)"
                        ></i>
                      </div>
                      <!-- comment love/like -->
                      <div v-if="isLogin" class="comment-action">
                        <div class="ca-wrap">
                          <div class="ca-box">
                            <span
                              :data-title="`${
                                disableLoveComment(comment.comm_id)
                                  ? 'Remove Love'
                                  : 'Love this Comment'
                              }`"
                              data-title-top
                              @click="CommentLoveLike('love', comment.comm_id)"
                            >
                              <a
                                class="icon-fire"
                                :class="{
                                  loved: disableLoveComment(comment.comm_id),
                                }"
                              ></a>
                            </span>
                            <span>
                              {{ getCommentLoveCount(comment.comm_id) }}
                            </span>
                          </div>
                          <div class="ca-box">
                            <span
                              :data-title="`${
                                disableLikeComment(comment.comm_id)
                                  ? 'Remove Like'
                                  : 'Like this Comment'
                              }`"
                              data-title-top
                              @click="CommentLoveLike('like', comment.comm_id)"
                            >
                              <a
                                class="icon-thumbs-up"
                                :class="{
                                  liked: disableLikeComment(comment.comm_id),
                                }"
                              ></a>
                            </span>
                            <span>
                              {{ getCommentLikeCount(comment.comm_id) }}</span
                            >
                          </div>
                          <div class="ca-box">
                            <span
                              class="view-toggle"
                              :class="{ opened: opendComment === index }"
                              title="Open/Close comments"
                              @click="toggleAccordion(index)"
                            >
                              <a
                                class="icon-reply"
                                v-if="opendComment !== index"
                              ></a>
                              <a class="icon-cancel" v-else></a>
                            </span>
                            <span v-if="comment.total_sub_comm > 0">
                              {{ comment.total_sub_comm }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="input-holder"
                      :class="{ opened: opendComment === index }"
                    >
                      <textarea
                        type="text"
                        v-model="subCommentText[index]"
                        placeholder="Add a comment ..."
                      />

                      <input
                        type="submit"
                        id="submit-comment-01"
                        class="button secondary"
                        value="REPLY"
                        @click.prevent="addSubComment(comment.comm_id, index)"
                        :disabled="
                          disableAddSubCommentButton || subCommentdoubleClick
                        "
                      />
                    </div>
                    <div
                      v-for="(sub, idx) in comment.sub_comm"
                      :key="idx"
                      class="sub-comment-wrapper"
                      :class="{ opened: opendComment === index }"
                    >
                      <div class="sub-comment-inner">
                        <span
                          @click="
                            goToCommentProfile(
                              sub.sub_cmt_user_uuid,
                              sub.sub_cmt_user_email
                            )
                          "
                        >
                          <div v-if="sub.sub_cmt_user_avatar !== null">
                            <img
                              class="pho-circs pho-2"
                              :title="`View ${sub.sub_cmt_user_fullname}`"
                              :src="sub.sub_cmt_user_avatar"
                              :alt="sub.sub_cmt_user_fullname"
                              :class="
                                sub.sub_cmt_user_avatar ===
                                'https://test-o2.s3-ap-southeast-2.amazonaws.com/avatars/logo-160.png'
                                  ? 'avatar-no-border'
                                  : ''
                              "
                            />
                          </div>
                          <div
                            v-else
                            class="small-user-img pho-circs pho-4"
                            :title="`View ${sub.sub_cmt_user_fullname}`"
                          ></div>

                          <div class="name_time_wrapper">
                            <span class="blue_text">
                              {{ sub.sub_cmt_user_fullname }}
                            </span>

                            <div>{{ subTimeAgo(sub.sub_cmmented_at) }}</div>
                          </div>
                        </span>

                        <div class="cs_text">
                          <i>"</i>
                          {{ sub.sub_comment }}
                          <i>"</i>
                        </div>
                        <div
                          data-title="Remove SubComment"
                          data-title-left
                          class="delete_btn"
                          v-if="user.email === post.author_email"
                        >
                          <i
                            class="icon-trash com-trash"
                            @click="removeSubComment(index, idx)"
                          ></i>
                        </div>
                        <div
                          data-title="Remove SubComment"
                          data-title-left
                          class="delete_btn"
                          v-else
                        >
                          <i
                            v-show="user.uuid === sub.sub_cmt_user_uuid"
                            class="icon-trash com-trash"
                            @click="removeSubComment(index, idx)"
                          ></i>
                        </div>
                      </div>
                    </div>
                    <div
                      class="btn_center_sec"
                      :class="{ opened: opendComment === index }"
                    >
                      <a
                        class="load_more_btn"
                        v-if="
                          isLogin &&
                          comment.sub_comm &&
                          comment.sub_comm.length < comment.total_sub_comm
                        "
                        @click="
                          loadMoreSubComments(
                            comment.comm_id,
                            comment.curr_page
                          )
                        "
                        >Show more <span class="icon-down-open"></span></a
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div v-else class="commentH_text">
                <i class="icon-commenting"></i>
                Add a Comment
              </div>
              <div v-if="!isLogin" class="post_comment_without_login">
                <div class="innerBox_wrapper">
                  <textarea readonly placeholder="Login to view ..."></textarea>
                  <div class="btn_wrapper">
                    <a
                      class="
                        button
                        primary
                        icon-lock-open
                        pr-15
                        pl-15
                        mt--5
                        mr-10
                      "
                      data-mobile="true"
                      title="Login"
                      @click="hideSidebar(0)"
                      >Login</a
                    >
                    <a
                      class="button primary icon-lock pr-15 pl-15 mt--5"
                      data-mobile="true"
                      title="Sign up"
                      @click="hideSidebar(3)"
                      >Sign up</a
                    >
                  </div>
                </div>
                <p class="pc_comment_tag_text">
                  It's much more fun when you're in!
                </p>
              </div>
            </li>
          </ul>
          <div
            class="admin-overlay"
            v-if="
              this.admin === true && user.email !== post.author_email && isLogin
            "
          >
            <div class="action-btn with-user-action">
              <div class="single-btn">
                <h4>Ban Post</h4>
                <button @click="banPost" :disabled="removeBanePost">
                  Ban Post
                </button>
              </div>
              <div
                class="single-btn two-btn"
                :class="{ disabled: this.baneUser === true }"
              >
                <div class="with-user-action">
                  <h4>Ban User</h4>
                  <b-dropdown
                    :text="selectedItem"
                    id="dropdown-dropup"
                    variant="primary"
                    class="m-2"
                    v-model="selectedItem"
                  >
                    <template #button-content v-if="!selectedItem"
                      >Select Time</template
                    >
                    <b-dropdown-item
                      v-for="time in list"
                      :key="time.id"
                      :value="time[1]"
                      @click="selectedItem = time[1] + ' ' + time[0]"
                    >
                      <span v-if="time[0] === 'Permanent'">{{ time[0] }}</span>
                      <span v-else>{{ time[1] }} {{ time[0] }}</span>
                    </b-dropdown-item>
                  </b-dropdown>
                </div>
                <div class="sb-wrap">
                  <h4 class="invisible">rmv</h4>
                  <button @click.once="userBane">YES</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <MatureAudienceLoginModal
          v-if="showLoginModal"
          @colseModal="colseModal"
        />
        <div class="btn_center_sec mainPost_loadmore">
          <a
            class="load_more_btn"
            v-if="isLogin && loadMoreToggle"
            @click="loadMoreComments"
            >Show more <span class="icon-down-open"></span></a
          >
        </div>
        <awardStarModal
          v-if="awardModalShow"
          :show="awardModalShow"
          :post_id="post.post_id"
          @toggle-modal="awardModalShow = !awardModalShow"
        />
      </perfect-scrollbar>
    </div>
    <div v-if="isOverlay" class="overlay-back" @click="$emit('close')"></div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import changeMyOzoneMixin from "@/mixins/ChangeMyOzoneMixin";
import LifeRemainingBarComponent from "../LifeRemainingBarComponent.vue";
import * as moment from "moment";
import axios from "axios";
import $ from "jquery";
import CommentTimeMixin from "@/mixins/CommentTimeMixin";
import modal from "../modal/modal.vue";
import reportPostModal from "../modal/reportPostModal.vue";
import showLeaderMessageMixin from "@/mixins/showLeaderMessageMixin";
import { BDropdown, BDropdownItem } from "bootstrap-vue";
import MatureAudienceLoginModal from "../../../components/modal/MatureAudienceLoginModal.vue";
import VueSlickCarousel from "vue-slick-carousel";
import VLazyImage from "v-lazy-image/v2";
import awardStarModal from "../modal/awardStarModal.vue";
import BoostToTop from "./BoostToTop.vue";

export default {
  name: "Overlay",
  props: {
    post: {
      type: Object,
    },
    isOverlay: {
      type: Boolean,
    },
    hasNext: {
      type: Boolean,
    },
    hasPrev: {
      type: Boolean,
    },
    new: {
      type: String,
    },
  },

  components: {
    LifeRemainingBarComponent,
    modal,
    reportPostModal,
    BDropdown,
    BDropdownItem,
    MatureAudienceLoginModal,
    VueSlickCarousel,
    VLazyImage,
    awardStarModal,
    BoostToTop,
  },

  mixins: [changeMyOzoneMixin, CommentTimeMixin, showLeaderMessageMixin],

  created: function () {
    this.timeAgo();
    this.subTimeAgo();
    this.postTimeAgo();
  },

  data() {
    return {
      opendComment: -1,
      activeLi: 0,
      copyButtonText: "Copy Url",
      commentText: "",
      subCommentText: [],
      comm_id: "",
      todayDate: moment().format("MMMM Do YYYY, h:mm:ss a"),
      modalShow: false,
      reportModalShow: false,
      post_id: "",
      errorMessage: "",
      setTimePeriod: {},
      list: [],
      selectedItem: "",
      toastMsg: {
        message: "",
        type: "success",
      },
      banePost: false,
      baneUser: false,
      closeLoginModal: false,
      loginModalShow: false,
      themeName: "",
      gold_count: 0,
      settings: {
        dots: true,
        dotsClass: "slick-dots custom-dot-class",
        edgeFriction: 0.35,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
        responsive: [
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              adaptiveHeight: true,
            },
          },
        ],
      },
      doubleClick: false,
      subCommentdoubleClick: false,
      awardModalShow: false,
      opendCountView: false,
      showComment: false,
      // fbResponse: null,
    };
  },

  computed: {
    ...mapState({
      user: (state) => state.auth.user,
      following: (state) => state.auth.following,
      isLogin: (state) => state.auth.isLogin,
      isDraft: (state) => state.common.isDraft,
      posts: (state) => state.homeModule.posts,
      myFavorites: (state) => state.common.myFavorites,
      myVotes: (state) => state.auth.user.votes,
      comments: (state) => state.overlayModule.comments,
      subComments: (state) => state.overlayModule.subComments,
      totalVotes: (state) => state.votingModule.totalVotes,
      totalNonVotePosts: (state) => state.votingModule.totalNonVotePosts,
      min_votes: (state) => state.votingModule.min_votes,
      max_votes: (state) => state.votingModule.max_votes,
      pageNumber: (state) => state.overlayModule.pageNumber,
      totalComments: (state) => state.overlayModule.totalComments,
      totalCommentsCount: (state) => state.overlayModule.totalCommentsCount,
      userEmail: (state) => state.auth.user.email,
      myPosts: (state) => state.userModule.posts,
      profilePosts: (state) => state.profileModule.posts,
      favPosts: (state) => state.favoriteModule.posts,
      searchPosts: (state) => state.searchModule.posts,
      admin: (state) => state.auth.admin,
      token: (state) => state.auth.token,
      follower_count: (state) => state.profileModule.follower_count,
      overlayClass: (state) => state.common.overlayClass,
      countData: (state) => state.overlayModule.countData,
      userData: (state) => state.overlayModule.userData,
      totalStar: (state) => state.overlayModule.totalStar,
      LovePost: (state) => state.overlayModule.LovePost,
      LikePost: (state) => state.overlayModule.LikePost,
      loveCount: (state) => state.overlayModule.loveCount,
      likeCount: (state) => state.overlayModule.likeCount,
      loveComment: (state) => state.overlayModule.loveComment,
      likeComment: (state) => state.overlayModule.likeComment,
      LoveLikeCommentCount: (state) => state.overlayModule.LoveLikeCommentCount,
      lifeSupport: (state) => state.overlayModule.lifeSupport,
    }),
    userAvatar() {
      if (this.user.avatar) {
        return this.user.avatar;
      } else {
        return process.env.VUE_APP_DEFAULT_IMG_URL;
      }
    },
    loadMoreToggle() {
      const limit = 10;
      return Math.ceil(this.totalComments / limit) > this.pageNumber
        ? true
        : false;
    },
    pressure() {
      switch (this.post.post_id) {
        case this.max_votes:
          return 99.99;
        case this.min_votes:
          return 0.01;
        default:
          if (this.totalVotes) {
            return (
              (this.post.votes / this.totalVotes) * 100 +
              this.post.post_id * 0.01
            ).toFixed(2);
          } else {
            return 0.0;
          }
      }
    },
    showVoter() {
      if (this.isLogin && this.$route.name !== "Winners") return true;
      return false;
    },
    showVoteBlock() {
      if (this.$route.name === "Home") {
        return true;
      }
      return false;
    },
    disableFollow() {
      if (!this.isLogin) return false;
      if (
        this.following &&
        this.following.find((item) => item.email === this.post.author_email)
      ) {
        return true;
      } else {
        return false;
      }
    },
    diableFavorite() {
      if (!this.isLogin) return false;
      if (this.myFavorites.find((item) => item === this.post.post_id))
        return true;
      return false;
    },
    postURL() {
      $("body").addClass("hero-overlay");
      return process.env.VUE_APP_PREFIX + "/post/" + this.post.uuid;
    },
    disableAddCommentButton() {
      return this.commentText === "" ? true : false;
    },
    disableAddSubCommentButton() {
      return this.subCommentText.length === 0 ? true : false;
    },
    baneUserDisable() {
      return this.baneUser === true ? true : false;
    },
    removeBanePost() {
      return this.banePost === true ? true : false;
    },
    link() {
      return process.env.VUE_APP_PREFIX + "/themes";
    },
    showLoginModal() {
      if (this.loginModalShow === true && !this.closeLoginModal) {
        return true;
      }
      return false;
    },
    disableLove() {
      if (!this.isLogin) return false;
      if (this.LovePost) {
        if (this.LovePost.find((item) => item === this.post.post_id))
          return true;
      }
      return false;
    },
    disableLike() {
      if (!this.isLogin) return false;
      if (this.LikePost) {
        if (this.LikePost.find((item) => item === this.post.post_id))
          return true;
      }
      return false;
    },
  },

  watch: {
    follower_count() {
      this.O2Theme();
    },
    post_id() {
      this.$store.dispatch("overlayModule/StarCount", {
        post: this.post.post_id,
      });
    },
    // fbResponse() {
    //   this.postShareCount();
    // },
  },

  async mounted() {
    this.$store.commit("set_overlay_class", "opened");

    // class for large screen view
    $(".full-content").addClass("full-screen");

    // for admin [select time period for ban user]
    this.setBanTimePeriod();
    if (this.isLogin) {
      await this.$store.dispatch("getFavorites");
      await this.$store.dispatch("overlayModule/GetLoveLikeData", {
        post: this.post.post_id,
      });
      await this.$store.dispatch("overlayModule/GetCommentLoveLikeData", {
        post: this.post.post_id,
      });
    }
    await this.$store.dispatch("overlayModule/PostTrack", {
      post: this.post.post_id,
      type: "post",
    });
    await this.$store.dispatch("overlayModule/StarCount", {
      post: this.post.post_id,
    });
    // for comment button in mobile screen
    if (window.innerWidth > 650) {
      this.showComment = true;
    }
  },

  destroyed() {
    this.$store.commit("set_overlay_class", "");
    this.$store.dispatch("resetPageNumber");
    $(".full-content").removeClass("full-screen");
  },

  methods: {
    scroll(elId) {
      setTimeout(() => {
        document.getElementById(elId).scrollIntoView({
          block: "center",
        });
      }, 100);
    },
    async getCountData() {
      this.opendCountView = !this.opendCountView;
      await this.$store.dispatch("overlayModule/StarCount", {
        post: this.post.post_id,
      });
    },
    async disableReportButton() {
      const data = {
        post_id: this.post.post_id,
      };
      const response = await this.$store.dispatch(
        "overlayModule/disableReportButton",
        data
      );
      if (response.data.data.reportedByUser === false) {
        this.reportModalShow = !this.reportModalShow;
      } else {
        this.errorMessage = response.data.message;
        setInterval(() => {
          this.errorMessage = "";
        }, 5000);
      }
    },
    async increment(postID) {
      this.$emit("increment", postID);
      const index = this.posts.findIndex((post) => post.post_id === postID);
      this.showLeaderMsg(postID, this.posts[index].votes, "");
      this.conffetti(postID, true);
    },
    async favIncrement(postID) {
      this.$emit("increment", postID);
      const index = this.favPosts.findIndex((post) => post.post_id === postID);
      this.showLeaderMsg(postID, this.favPosts[index].votes, "");
      this.conffetti(postID, true);
    },
    async userIncrement(postID) {
      this.$emit("increment", postID);
      const index = this.myPosts.findIndex((post) => post.post_id === postID);
      this.showLeaderMsg(postID, this.myPosts[index].votes, "");
      this.conffetti(postID, true);
    },
    async profileIncrement(postID) {
      this.$emit("increment", postID);
      const index = this.profilePosts.findIndex(
        (post) => post.post_id === postID
      );
      this.showLeaderMsg(postID, this.profilePosts[index].votes, "");
      this.conffetti(postID, true);
    },
    async searchIncrement(postID) {
      this.$emit("increment", postID);
      const index = this.searchPosts.findIndex(
        (post) => post.post_id === postID
      );
      this.showLeaderMsg(postID, this.searchPosts[index].votes, "");
      this.conffetti(postID, true);
    },
    displayVoteBlock() {
      if (this.$route.path !== "/leaderboard") {
        return true;
      }
      return false;
    },
    postShareCount() {
      this.$store.dispatch("overlayModule/PostTrack", {
        post: this.post.post_id,
        type: "share",
      });
    },
    shareFacebook(postId) {
      window.open(
        "http://www.facebook.com/sharer.php?u=" +
          process.env.VUE_APP_API_URL +
          "/posts/social-sharing/" +
          postId,
        "",
        "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600"
      );
      this.postShareCount();
    },
    shareTwitter(postId) {
      window.open(
        "https://twitter.com/intent/tweet?url=" +
          process.env.VUE_APP_API_URL +
          "/posts/social-sharing/" +
          postId,
        "",
        "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600"
      );
      this.postShareCount();
    },
    sharePinterest(postId) {
      window.open(
        "http://pinterest.com/pin/create/button/?url=" +
          process.env.VUE_APP_API_URL +
          "/posts/social-sharing/" +
          postId,
        "",
        "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600"
      );
      this.postShareCount();
    },
    async handleSubmit(data) {
      data.postId = this.post.post_id;
      if (this.isLogin) {
        data.user = "yes";
      } else {
        data.user = "no";
      }
      this.modalShow = false;
      const res = await this.$store.dispatch(
        "overlayModule/emailSharing",
        data
      );
      if (res.status === 200) {
        this.postShareCount();
      }
    },
    toggleAccordion(index) {
      if (index === this.opendComment) {
        this.opendComment = -1;
      } else {
        this.opendComment = index;
      }
    },
    loadMoreComments() {
      this.$store.dispatch(
        "overlayModule/loadMoreComments",
        this.post.post_id,
        { pageNumber: this.pageNumber }
      );
    },
    loadMoreSubComments(comm_id, subPageNum) {
      const data = { comm_id: comm_id, subPageNum: subPageNum };
      this.$store.dispatch("overlayModule/loadMoreSubComments", data);
    },
    async addComment() {
      let $this = this;
      let data = {
        post_id: $this.post.post_id,
        comment_text: $this.commentText,
        post_author: $this.post.author_email,
      };
      this.doubleClick = true;
      if (this.commentText !== " ") {
        const add_comment = await this.$store.dispatch("addComment", data);
        this.doubleClick = false;

        if (add_comment.status === 200) {
          if ($this.comments.length < 2) {
            $this.comments.unshift({
              cmt_user_uuid: $this.user.uuid,
              cmt_user_fullname:
                $this.user.first_name + " " + $this.user.last_name,
              cmt_user_avatar: $this.user.avatar,
              comment: $this.commentText,
              comm_id: add_comment.data.comm_id,
              total_sub_comm: 0,
              sub_comm: [],
            });
            this.$store.commit("overlayModule/SET_COMMENTS_COUNT", 1);
            this.$store.commit("overlayModule/SET_TOTAL_COMMENTS_COUNT", 1);
          } else {
            this.$store.commit("overlayModule/SET_PAGE_NUMBER", 0);
            await this.$store.dispatch(
              "overlayModule/getComments",
              this.post.post_id
            );
          }
          this.$store.commit("userModule/INCREASE_UNREAD_COUNT", 1);
          this.commentText = "";
        }
      }
    },
    async addSubComment(id, subCommIdx) {
      let $this = this;
      let data = {
        post_id: $this.post.post_id,
        comm_id: id,
        sub_comm_text: $this.subCommentText[subCommIdx],
        post_author: $this.post.author_email,
      };
      this.subCommentdoubleClick = true;
      if (this.subCommentText !== []) {
        const add_sub_comment = await this.$store.dispatch(
          "addSubComment",
          data
        );
        this.subCommentdoubleClick = false;
        if (add_sub_comment.status === 200) {
          const index = this.comments.findIndex((item) => item.comm_id === id);
          if (this.comments[index].sub_comm.length < 2) {
            $this.comments[index].sub_comm.unshift({
              sub_cmt_user_uuid: $this.user.uuid,
              sub_cmt_user_fullname:
                $this.user.first_name + " " + $this.user.last_name,
              sub_cmt_user_avatar: $this.user.avatar,
              sub_comment: $this.subCommentText[subCommIdx],
              sub_comm_id: add_sub_comment.data,
            });
          } else {
            this.comments[index].sub_comm = [];
            const subData = {
              comm_id: this.comments[index].comm_id,
              subPageNum: 0,
            };
            await this.$store.commit(
              "overlayModule/SET_SUB_COMMENT_CURR_PAGE",
              this.comments[index].comm_id
            );
            await this.$store.dispatch(
              "overlayModule/loadMoreSubComments",
              subData
            );
          }
          this.subCommentText = [];
          $this.comments[index].total_sub_comm =
            $this.comments[index].total_sub_comm + 1;
          this.$store.commit("overlayModule/SET_TOTAL_COMMENTS_COUNT", 1);
          this.$store.commit("userModule/INCREASE_UNREAD_COUNT", 1);
        }
      }
    },
    async removeComment(index) {
      let comment_id = this.comments[index].comm_id;
      let subCommentCount = this.comments[index].total_sub_comm;
      subCommentCount = subCommentCount + 1;
      let data = {
        index: index,
        comment_id: comment_id,
      };
      const response = await this.$store.dispatch(
        "overlayModule/removeComment",
        data
      );
      if (response.status === 200) {
        this.$store.commit(
          "overlayModule/SET_TOTAL_COMMENTS_COUNT",
          -subCommentCount
        );
        await this.$store.commit(
          "userModule/INCREASE_UNREAD_COUNT",
          -subCommentCount
        );
        if (this.comments.length < 2) {
          await this.$store.dispatch(
            "overlayModule/getComments",
            this.post.post_id
          );
        }
      }
    },
    async removeSubComment(index, idx) {
      let sub_comment_id = this.comments[index].sub_comm[idx].sub_comm_id;
      let data = {
        index: index,
        idx: idx,
        sub_comment_id: sub_comment_id,
      };
      const response = await this.$store.dispatch(
        "overlayModule/removeSubComment",
        data
      );
      if (response.status === 200) {
        if (
          this.comments[index].sub_comm.length < 2 &&
          this.comments[index].total_sub_comm > 1
        ) {
          this.comments[index].sub_comm = [];
          const subData = {
            comm_id: this.comments[index].comm_id,
            subPageNum: 0,
          };
          await this.$store.dispatch(
            "overlayModule/loadMoreSubComments",
            subData
          );
        }
        await this.$store.commit("overlayModule/SET_TOTAL_COMMENTS_COUNT", -1);
        await this.$store.commit("userModule/INCREASE_UNREAD_COUNT", -1);
      }
    },
    copyURL() {
      let $this = this;
      const el = document.createElement("textarea");
      el.value = $this.postURL;
      el.setAttribute("readonly", "");
      el.style.position = "absolute";
      el.style.left = "-9999px";
      document.body.appendChild(el);
      const selected =
        document.getSelection().rangeCount > 0
          ? document.getSelection().getRangeAt(0)
          : false;
      el.select();
      document.execCommand("copy");
      this.copyButtonText = "Copied";
      document.body.removeChild(el);
      if (selected) {
        document.getSelection().removeAllRanges();
        document.getSelection().addRange(selected);
      }
    },
    colseModal() {
      this.closeLoginModal = true;
      this.loginModalShow = false;
      this.closeLoginModal = false;
      $(".col-trigger").removeClass("sidebar-hide");
      $(".show-mnav").removeClass("sidebar-hide");
      $(".sidebar-right").removeClass("sidebar-hide");
      $(".overlay").removeClass("login-modal-open");
      this.removeSidebar();
    },
    editPost() {
      this.$emit("editPost");
      this.$store.dispatch("uxModule/editingPost", true);
      this.$store.commit("set_edit_post_overlay_class", "opened");
      this.$emit("close");
    },
    async addToFavorite() {
      await this.$store.dispatch("getFavorites");
      let $this = this;
      let data = {
        post_id: $this.post.post_id,
      };
      await this.$store.dispatch("addToFavorites", data);
      await this.$store.dispatch("getFavorites");
    },
    async removeFavourite(postID) {
      await this.$store.dispatch("getFavorites");
      await this.$store.dispatch("favoriteModule/deletePost", postID);
      await this.$store.dispatch("getFavorites");
    },
    clickFavButton() {
      if (this.diableFavorite) {
        return this.removeFavourite(this.post.post_id);
      } else {
        return this.addToFavorite();
      }
    },
    async addToLoveLike(type) {
      const data = {
        type: type,
        post: this.post.post_id,
      };
      await this.$store.dispatch("overlayModule/PostLoveLike", data);
      await this.$store.dispatch("overlayModule/GetLoveLikeData", {
        post: this.post.post_id,
      });
    },
    async removeLoveLike(type) {
      const data = {
        type: type,
        post: this.post.post_id,
      };
      await this.$store.dispatch("overlayModule/removeLoveLike", data);
      await this.$store.dispatch("overlayModule/GetLoveLikeData", {
        post: this.post.post_id,
      });
    },
    async clickLoveLikeButton(type) {
      if (type === "love") {
        if (this.disableLove) {
          await this.removeLoveLike(type);
        } else if (this.disableLike) {
          await this.removeLoveLike("like");
          await this.addToLoveLike("love");
        } else {
          await this.addToLoveLike(type);
        }
      } else {
        if (this.disableLike) {
          await this.removeLoveLike(type);
        } else if (this.disableLove) {
          await this.removeLoveLike("love");
          await this.addToLoveLike("like");
        } else {
          await this.addToLoveLike(type);
        }
      }
    },
    disableLikeComment(comm_id) {
      if (!this.isLogin) return false;
      if (this.likeComment) {
        if (this.likeComment.find((item) => item === comm_id)) return true;
      }
      return false;
    },
    disableLoveComment(comm_id) {
      if (!this.isLogin) return false;
      if (this.loveComment) {
        if (this.loveComment.find((item) => item === comm_id)) return true;
      }
      return false;
    },
    async addCommentToLoveLike(type, comment_id) {
      const data = {
        type: type,
        comment: comment_id,
        post: this.post.post_id,
      };
      await this.$store.dispatch("overlayModule/CommentLoveLike", data);
      await this.$store.dispatch("overlayModule/GetCommentLoveLikeData", {
        post: this.post.post_id,
      });
    },
    async removeCommentLoveLike(type, comm_id) {
      const data = {
        type: type,
        comment: comm_id,
        post: this.post.post_id,
      };
      await this.$store.dispatch("overlayModule/removeCommentLoveLike", data);
      await this.$store.dispatch("overlayModule/GetCommentLoveLikeData", {
        post: this.post.post_id,
      });
    },
    async CommentLoveLike(type, comment_id) {
      if (type === "love") {
        if (this.disableLoveComment(comment_id)) {
          await this.removeCommentLoveLike(type, comment_id);
        } else if (this.disableLikeComment(comment_id)) {
          await this.removeCommentLoveLike("like", comment_id);
          await this.addCommentToLoveLike("love", comment_id);
        } else {
          await this.addCommentToLoveLike(type, comment_id);
        }
      } else {
        if (this.disableLikeComment(comment_id)) {
          await this.removeCommentLoveLike(type, comment_id);
        } else if (this.disableLoveComment(comment_id)) {
          await this.removeCommentLoveLike("love", comment_id);
          await this.addCommentToLoveLike("like", comment_id);
        } else {
          await this.addCommentToLoveLike(type, comment_id);
        }
      }
    },
    calExpiration(e) {
      let color = e < 70.0 ? "blue" : "red";
      return color;
    },
    async follow() {
      if (!this.disableFollow) {
        let $this = this;
        let data = {
          user_email: $this.post.author_email,
        };
        await $this.$store.dispatch("follow", data);
      }
    },
    unFollow(email) {
      let $this = this;
      let data = {
        user_email: $this.post.author_email,
      };
      axios({
        url: "follower/remove-follow/",
        data: data,
        method: "POST",
      })
        .then((response) => {
          if (response.status === 200) {
            $this.$store.commit("removeFollowing", email);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    clickButton() {
      if (this.disableFollow) {
        return this.unFollow(this.post.author_email);
      } else {
        return this.follow();
      }
    },
    async O2Theme() {
      await axios({
        url: "auth/user/o2-theme",
        method: "get",
      })
        .then((response) => {
          response.data.map((item) => {
            if (item.theme_type === "rewarded") {
              if (item.theme_name === "gold") {
                this.gold_count = item.follower_count;
              }
              if (this.follower_count >= item.follower_count) {
                this.themeName = item.theme_name;
                this.$store.commit("set_selected_theme", this.themeName);
              }
            }
            if (this.follower_count < this.gold_count) {
              this.$store.commit("set_selected_theme", "o2");
            }
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    removeSidebar() {
      let $this = this;
      $("body").removeClass("mpanel-open hidesb");
      $(".ozone-column").removeClass("moved");
      $(".my-ozone").removeClass("moved");
      $this.$store.commit("change_state", ["mnav_class", ""]);
      setTimeout(function () {
        $this.$store.commit("change_state", ["mnav_close_class", ""]);
      }, 350);
    },
    hideSidebar(num) {
      this.$emit("close");
      let $this = this;
      $this.changeMyOzone(num);
      $("body").addClass("mpanel-open hidesb");
      $(".logged-out").addClass("hidesb");
      $(".ozone-column").addClass("moved");
      $(".my-ozone").addClass("moved");
      $this.$store.commit("change_state", ["mnav_class", "move"]);
      setTimeout(function () {
        $this.$store.commit("change_state", ["mnav_close_class", "slidem"]);
      }, 350);
    },
    goToProfile() {
      if (this.isLogin) {
        let $this = this;
        if ($this.userEmail === $this.post.author_email) {
          if ($this.$route.name !== "User")
            $this.$router.push({ name: "User" });
        } else {
          if ($this.$route.name !== "Profile") {
            $this.$router.push({
              name: "Profile",
              params: {
                uuid: $this.post.author_uuid,
              },
            });
          }
        }
        this.$emit("close");
      } else {
        this.loginModalShow = true;
        $(".col-trigger").addClass("sidebar-hide");
        $(".sidebar-right").addClass("sidebar-hide");
        $(".show-mnav").addClass("sidebar-hide");
        $(".overlay").addClass("login-modal-open");
        $("body").removeClass("hero-overlay");
        this.removeSidebar();
      }
    },
    goToCommentProfile(uuid, email) {
      let $this = this;
      if ($this.userEmail === email) {
        if ($this.$route.name !== "User") $this.$router.push({ name: "User" });
      } else {
        if ($this.$route.name !== "Profile") {
          $this.$router.push({
            name: "Profile",
            params: {
              uuid: uuid,
            },
          });
        }
      }
      this.$emit("close");
    },
    reportPost(data) {
      data.post_id = this.post.post_id;
      axios({
        url: "/posts/report-post/",
        data: data,
        method: "POST",
      })
        .then((response) => {
          if (response.status === 200) {
            this.$emit("close");
          }
        })
        .catch((error) => {
          console.log(error);
        });
      this.reportModalShow = false;
    },
    removePost() {
      this.$emit("removePost");
      this.$store.commit("remove_leaders", this.post);
      this.$emit("close");
    },
    async searchTag(tag) {
      this.$store.dispatch("searchModule/setQuery", {
        filter: 2,
        query: tag,
      });
      const postData = await this.$store.dispatch("searchModule/search");
      this.$store.dispatch("votingModule/setVotes", postData);
      if (this.$route.name !== "Search") {
        this.$router.push({
          name: "Search",
        });
      }
      this.$emit("close");
    },
    async banPost() {
      const response = await this.$store.dispatch(
        "overlayModule/banPost",
        this.post.post_id
      );
      this.banePost = true;
      await this.$store.dispatch("showToast", {
        message: response.data.message,
      });
    },
    async userBane() {
      await axios({
        url: "/posts/bane-user/",
        method: "post",
        data: {
          post_id: this.post.post_id,
          timePeriod: this.selectedItem,
        },
      })
        .then((response) => {
          this.baneUser = true;
          this.$store.dispatch("showToast", {
            message: response.data.message,
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async setBanTimePeriod() {
      const tmp = await this.$store.dispatch("setBanTime", this.post.post_id);
      this.baneUser = tmp.userBan;
      this.setTimePeriod = tmp.data;
      const entries = Object.entries(this.setTimePeriod);
      this.list = entries;
    },
    trophyClass(theme) {
      if (theme === "gold") {
        return "gold-trophy";
      } else if (theme === "platinum") {
        return "platinum-trophy";
      } else if (theme === "diamond") {
        return "diamond-trophy";
      } else {
        return "";
      }
    },
    toCapital(author_theme) {
      return (
        author_theme[0].toUpperCase() + author_theme.slice(1) + " " + "Member"
      );
    },
    limit2numbers(value) {
      var duration = moment.duration(value, "hours");
      const d = moment.duration(duration);
      const days = Math.abs(d._data.days);
      const hours = Math.abs(d._data.hours);
      const minutes = Math.abs(d._data.minutes);
      return days + "d" + ":" + hours + "h" + ":" + minutes + "m";
    },
    getCommentLoveCount(comm_id) {
      if (this.LoveLikeCommentCount) {
        const comment = this.LoveLikeCommentCount.find(
          (item) => item.comm_id === comm_id
        );
        if (comment) {
          if (comment.loveCount > 0) {
            return comment.loveCount;
          }
        }
      }
    },
    getCommentLikeCount(comm_id) {
      if (this.LoveLikeCommentCount) {
        const comment = this.LoveLikeCommentCount.find(
          (item) => item.comm_id === comm_id
        );
        if (comment) {
          if (comment.likeCount > 0) {
            return comment.likeCount;
          }
        }
      }
    },
  },
};
</script>